import { createSecureChannel } from '../abc/securechannel';
import { delegateRlp } from '../abc/transactions';
import { ethers } from 'ethers';
import { Eip1559Result } from '../../index';
import { feePayerSign, hashSign } from '~/services/abcWaas/transaction';
import { createCompactSignature } from './signature';

export const getFeePayerSignatureHex = async (txData: any) => {
    // TODO : secure channel can be expired. So refresh it before each tx.
    await createSecureChannel();

    const strSecureChannel = window.sessionStorage.getItem('secureChannel') || '{}';
    const secureChannel = JSON.parse(strSecureChannel);
    console.log('=== secure channel : ', secureChannel);

    try {
        const rlpHash = await delegateRlp({
            signer: 'feepayer',
            ...txData,
        });

        /*
         * TODO: via Backend
         * 프론트에서 직접 보내는 경우, FeePayer의 키쉐어가 자바스크립트 코드에 추가되어 사용자 브라우저로 유출됨.
         * fePayer 서명을 백엔드에서 처리.
         */
        const feePayerSignatureHex = await feePayerSign(
            {
                hash: rlpHash,
            },
            strSecureChannel,
        );
        console.log('=== feePayerSignatureHex : ', feePayerSignatureHex);

        let compact = '';
        if (feePayerSignatureHex) {
            const sigJson = JSON.parse(feePayerSignatureHex ?? '{}');
            const { r, s, vsource } = sigJson.sig_list[0];
            console.log('>>>>>>', { r, s, vsource });
            compact = createCompactSignature(r, s, vsource);
            console.log('=== feePayerSignatureHex compact : ', compact);
        }
        return compact;
    } catch (err: any) {
        console.error(err?.message);
    }
};
